<script lang="ts">
  import { Table } from "flowbite-svelte";
</script>

<Table striped={true} hoverable={true}><slot /></Table>
